/*
Google Maps Geometry Library v3 - 33.10
*/
export let GoogleGeometry = {
  maps: {}
};
// _ google functions
let wb = function (a, b, c) {
  c -= b;
  return ((((a - b) % c) + c) % c) + b;
};
let rb = function (a) {
  return (a * Math.PI) / 180;
};
let sb = function (a) {
  return (180 * a) / Math.PI;
};
let H = function (a, b) {
  this.x = a;
  this.y = b;
};
let l = function () {
  return function () {};
};
let $c = function (a) {
  this.b = a || [];
  Zc(this);
};
let Zc = function (a) {
  a.set('length', a.b.length);
};
let hc = function (a) {
  return rb(a.lat());
};
let Mb = function (a, b) {
  var c = c ? c + ': ' : '';
  return function (d) {
    if (!d || !Bb(d)) throw Kb(c + 'not an Object');
    var e = {},
      f;
    for (f in d) if (((e[f] = d[f]), !b && !a[f])) throw Kb(c + 'unknown property ' + f);
    for (f in a)
      try {
        var g = a[f](e[f]);
        if (q(g) || Object.prototype.hasOwnProperty.call(d, f)) e[f] = a[f](e[f]);
      } catch (h) {
        throw Kb(c + 'in property ' + f, h);
      }
    return e;
  };
};
let F = function (a) {
  return 'number' == typeof a;
};
let Ib = function (a) {
  this.message = a;
  this.name = 'InvalidValueError';
  this.stack = Error().stack;
};

let Kb = function (a, b) {
  var c = '';
  if (null != b) {
    if (!(b instanceof Ib)) return b;
    c = ': ' + b.message;
  }
  return new Ib(a + c);
};
let Rb = function (a, b) {
  return function (c) {
    if (a(c)) return c;
    throw Kb(b || '' + c);
  };
};
let Vb = Rb(F, 'not a number');
var gc = Mb(
  {
    lat: Vb,
    lng: Vb
  },
  !0
);
let ic = function (a) {
  return rb(a.lng());
};
let K = (GoogleGeometry.maps.LatLng = function (a, b, c) {
  if (a && (void 0 !== a.lat || void 0 !== a.lng))
    try {
      (gc(a), (b = a.lng), (a = a.lat), (c = !1));
    } catch (d) {
      Lb(d);
    }
  a -= 0;
  b -= 0;
  c || ((a = vb(a, -90, 90)), 180 != b && (b = wb(b, -180, 180)));
  this.lat = function () {
    return a;
  };
  this.lng = function () {
    return b;
  };
});
let E = function (a) {
  return a ? a.length : 0;
};
let vb = function (a, b, c) {
  null != b && (a = Math.max(a, b));
  null != c && (a = Math.min(a, c));
  return a;
};
let Lb = function (a) {
  if (!(a instanceof Ib)) throw a;
  Hb(a.name + ': ' + a.message);
};
let Hb = function (a) {
  console.error(a);
};
let q = function (a) {
  return void 0 !== a;
};
let Bb = function (a) {
  return 'object' == typeof a;
};
//Geometry Library
var wr = function (a, b) {
    return Math.abs(wb(b - a, -180, 180));
  },
  xr = function (a, b, c, d, e) {
    if (!d) {
      c = wr(a.lng(), c) / wr(a.lng(), b.lng());
      if (!e)
        return (
          (e = Math.sin(rb(a.lat()))),
          (e = Math.log((1 + e) / (1 - e)) / 2),
          (b = Math.sin(rb(b.lat()))),
          sb(2 * Math.atan(Math.exp(e + c * (Math.log((1 + b) / (1 - b)) / 2 - e))) - Math.PI / 2)
        );
      a = e.fromLatLngToPoint(a);
      b = e.fromLatLngToPoint(b);
      return e.fromPointToLatLng(new H(a.x + c * (b.x - a.x), a.y + c * (b.y - a.y))).lat();
    }
    e = rb(a.lat());
    a = rb(a.lng());
    d = rb(b.lat());
    b = rb(b.lng());
    c = rb(c);
    return wb(
      sb(
        Math.atan2(
          Math.sin(e) * Math.cos(d) * Math.sin(c - b) - Math.sin(d) * Math.cos(e) * Math.sin(c - a),
          Math.cos(e) * Math.cos(d) * Math.sin(a - b)
        )
      ),
      -90,
      90
    );
  },
  yr = l(),
  zr = {
    containsLocation: function (a, b) {
      var c = wb(a.lng(), -180, 180),
        d = !!b.get('geodesic'),
        e = b.get('latLngs'),
        f = b.get('map');
      f = !d && f ? f.getProjection() : null;
      for (var g = !1, h = 0, k = e.getLength(); h < k; ++h)
        for (var n = e.getAt(h), p = 0, r = n.getLength(); p < r; ++p) {
          var t = n.getAt(p),
            v = n.getAt((p + 1) % r),
            x = wb(t.lng(), -180, 180),
            w = wb(v.lng(), -180, 180),
            z = Math.max(x, w);
          x = Math.min(x, w);
          (180 < z - x ? c >= z || c < x : c < z && c >= x) && xr(t, v, c, d, f) < a.lat() && (g = !g);
        }
      return g || zr.isLocationOnEdge(a, b);
    },
    isLocationOnEdge: function (a, b, c) {
      c = c || 1e-9;
      var d = wb(a.lng(), -180, 180),
        e = true,
        f = !!b.get('geodesic'),
        g = b.get('latLngs');
      b = b.get('map');
      b = !f && b ? b.getProjection() : null;
      for (var h = 0, k = g.getLength(); h < k; ++h)
        for (var n = g.getAt(h), p = n.getLength(), r = e ? p : p - 1, t = 0; t < r; ++t) {
          var v = n.getAt(t),
            x = n.getAt((t + 1) % p),
            w = wb(v.lng(), -180, 180),
            z = wb(x.lng(), -180, 180),
            B = Math.max(w, z),
            D = Math.min(w, z);
          if (
            (w = 1e-9 >= Math.abs(wb(w - z, -180, 180)) && (Math.abs(wb(w - d, -180, 180)) <= c || Math.abs(wb(z - d, -180, 180)) <= c))
          ) {
            w = a.lat();
            z = Math.min(v.lat(), x.lat()) - c;
            var I = Math.max(v.lat(), x.lat()) + c;
            w = w >= z && w <= I;
          }
          if (w) return !0;
          if (180 < B - D ? d + c >= B || d - c <= D : d + c >= D && d - c <= B)
            if (((v = xr(v, x, d, f, b)), Math.abs(v - a.lat()) < c)) return !0;
        }
      return !1;
    }
  };
var Ar = {
  computeHeading: function (a, b) {
    a = a instanceof GoogleGeometry.maps.LatLng ? a : new GoogleGeometry.maps.LatLng(a.lat, a.lng);
    b = b instanceof GoogleGeometry.maps.LatLng ? b : new GoogleGeometry.maps.LatLng(b.lat, b.lng);
    var c = hc(a),
      d = ic(a);
    a = hc(b);
    b = ic(b) - d;
    return wb(sb(Math.atan2(Math.sin(b) * Math.cos(a), Math.cos(c) * Math.sin(a) - Math.sin(c) * Math.cos(a) * Math.cos(b))), -180, 180);
  },
  computeOffset: function (a, b, c, d) {
    b /= d || 6378137;
    c = rb(c);
    var e = hc(a);
    a = ic(a);
    d = Math.cos(b);
    b = Math.sin(b);
    var f = Math.sin(e);
    e = Math.cos(e);
    var g = d * f + b * e * Math.cos(c);
    return new K(sb(Math.asin(g)), sb(a + Math.atan2(b * e * Math.sin(c), d - f * g)));
  },
  computeOffsetOrigin: function (a, b, c, d) {
    c = rb(c);
    b /= d || 6378137;
    d = Math.cos(b);
    var e = Math.sin(b) * Math.cos(c);
    b = Math.sin(b) * Math.sin(c);
    c = Math.sin(hc(a));
    var f = e * e * d * d + d * d * d * d - d * d * c * c;
    if (0 > f) return null;
    var g = e * c + Math.sqrt(f);
    g /= d * d + e * e;
    var h = (c - e * g) / d;
    g = Math.atan2(h, g);
    if (g < -Math.PI / 2 || g > Math.PI / 2) ((g = e * c - Math.sqrt(f)), (g = Math.atan2(h, g / (d * d + e * e))));
    if (g < -Math.PI / 2 || g > Math.PI / 2) return null;
    a = ic(a) - Math.atan2(b, d * Math.cos(g) - e * Math.sin(g));
    return new K(sb(g), sb(a));
  },
  interpolate: function (a, b, c) {
    a = a instanceof GoogleGeometry.maps.LatLng ? a : new GoogleGeometry.maps.LatLng(a.lat, a.lng);
    b = b instanceof GoogleGeometry.maps.LatLng ? b : new GoogleGeometry.maps.LatLng(b.lat, b.lng);
    var d = hc(a),
      e = ic(a),
      f = hc(b),
      g = ic(b),
      h = Math.cos(d),
      k = Math.cos(f);
    b = Ar.yf(a, b);
    var n = Math.sin(b);
    // if (1E-6 > n)
    //     return new K(a.lat(),a.lng());
    a = Math.sin((1 - c) * b) / n;
    c = Math.sin(c * b) / n;
    b = a * h * Math.cos(e) + c * k * Math.cos(g);
    e = a * h * Math.sin(e) + c * k * Math.sin(g);
    return new K(sb(Math.atan2(a * Math.sin(d) + c * Math.sin(f), Math.sqrt(b * b + e * e))), sb(Math.atan2(e, b)));
  },
  yf: function (a, b) {
    var c = hc(a);
    a = ic(a);
    var d = hc(b);
    b = ic(b);
    return 2 * Math.asin(Math.sqrt(Math.pow(Math.sin((c - d) / 2), 2) + Math.cos(c) * Math.cos(d) * Math.pow(Math.sin((a - b) / 2), 2)));
  },
  computeDistanceBetween: function (a, b, c) {
    c = c || 6378137;
    return Ar.yf(a, b) * c;
  },
  computeLength: function (a, b) {
    b = b || 6378137;
    var c = 0;
    a instanceof $c && (a = a.getArray());
    for (var d = 0, e = a.length - 1; d < e; ++d) c += Ar.computeDistanceBetween(a[d], a[d + 1], b);
    return c;
  },
  computeArea: function (a, b) {
    return Math.abs(Ar.computeSignedArea(a, b));
  },
  computeSignedArea: function (a, b) {
    b = b || 6378137;
    a instanceof $c && (a = a.getArray());
    for (var c = a[0], d = 0, e = 1, f = a.length - 1; e < f; ++e) d += Ar.Qk(c, a[e], a[e + 1]);
    return d * b * b;
  },
  Qk: function (a, b, c) {
    return Ar.Rk(a, b, c) * Ar.Nl(a, b, c);
  },
  Rk: function (a, b, c) {
    var d = [a, b, c, a];
    a = [];
    for (c = b = 0; 3 > c; ++c) ((a[c] = Ar.yf(d[c], d[c + 1])), (b += a[c]));
    b /= 2;
    d = Math.tan(b / 2);
    for (c = 0; 3 > c; ++c) d *= Math.tan((b - a[c]) / 2);
    return 4 * Math.atan(Math.sqrt(Math.abs(d)));
  },
  Nl: function (a, b, c) {
    a = [a, b, c];
    b = [];
    for (c = 0; 3 > c; ++c) {
      var d = a[c],
        e = hc(d);
      d = ic(d);
      var f = (b[c] = []);
      f[0] = Math.cos(e) * Math.cos(d);
      f[1] = Math.cos(e) * Math.sin(d);
      f[2] = Math.sin(e);
    }
    return 0 <
      b[0][0] * b[1][1] * b[2][2] +
        b[1][0] * b[2][1] * b[0][2] +
        b[2][0] * b[0][1] * b[1][2] -
        b[0][0] * b[2][1] * b[1][2] -
        b[1][0] * b[0][1] * b[2][2] -
        b[2][0] * b[1][1] * b[0][2]
      ? 1
      : -1;
  }
};
var Br = {
  decodePath: function (a) {
    for (var b = E(a), c = Array(Math.floor(a.length / 2)), d = 0, e = 0, f = 0, g = 0; d < b; ++g) {
      var h = 1,
        k = 0;
      do {
        var n = a.charCodeAt(d++) - 63 - 1;
        h += n << k;
        k += 5;
      } while (31 <= n);
      e += h & 1 ? ~(h >> 1) : h >> 1;
      h = 1;
      k = 0;
      do ((n = a.charCodeAt(d++) - 63 - 1), (h += n << k), (k += 5));
      while (31 <= n);
      f += h & 1 ? ~(h >> 1) : h >> 1;
      c[g] = new K(1e-5 * e, 1e-5 * f, !0);
    }
    c.length = g;
    return c;
  },
  encodePath: function (a) {
    a instanceof $c && (a = a.getArray());
    return Br.an(a, function (a) {
      return [Math.round(1e5 * a.lat()), Math.round(1e5 * a.lng())];
    });
  },
  an: function (a, b) {
    for (var c = [], d = [0, 0], e, f = 0, g = E(a); f < g; ++f)
      ((e = b ? b(a[f]) : a[f]), Br.ti(e[0] - d[0], c), Br.ti(e[1] - d[1], c), (d = e));
    return c.join('');
  },
  ti: function (a, b) {
    return Br.bn(0 > a ? ~(a << 1) : a << 1, b);
  },
  bn: function (a, b) {
    for (; 32 <= a; ) (b.push(String.fromCharCode((32 | (a & 31)) + 63)), (a >>= 5));
    b.push(String.fromCharCode(a + 63));
    return b;
  }
};
GoogleGeometry.maps.geometry = {
  encoding: Br,
  spherical: Ar,
  poly: zr
};

// m = yr.prototype;
// m.decodePath = Br.decodePath;
// m.encodePath = Br.encodePath;
// m.computeDistanceBetween = Ar.computeDistanceBetween;
// m.interpolate = Ar.interpolate;
// m.computeHeading = Ar.computeHeading;
// m.computeOffset = Ar.computeOffset;
// m.computeOffsetOrigin = Ar.computeOffsetOrigin;
// Vd("geometry", new yr);
